module.exports = __webpack_public_path__ + "static/media/poorwill12.8245027d.JPG";